import { RelatedTag } from '@empathy/search-types';
import { QuerySignalsState } from '../../../models';
import { QUERY_SIGNALS_GETTERS_KEYS } from '../query-signals.const';
import { QuerySignalsGetter } from '../query-signals.interfaces';

export class SelectedRelatedTagsGetter implements QuerySignalsGetter {

  getters = {
    [QUERY_SIGNALS_GETTERS_KEYS.selectedRelatedTags]: (querySignalsState: QuerySignalsState): RelatedTag[] =>
      querySignalsState.relatedTags.filter(tag => tag.selected)
  };
}
